import { render, staticRenderFns } from "./ModalMedicalAction.vue?vue&type=template&id=4f6feb2b&"
import script from "./ModalMedicalAction.vue?vue&type=script&lang=js&"
export * from "./ModalMedicalAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports